
window.dawn = window.dawn || {};
window.Shopify = window.Shopify || {};
dawn.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};
(function(){
  'use strict';
    dawn.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
    // Init section function when it's visible, then disable observer
  dawn.dawninitWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
    // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = dawn.delegate.on;
  window.off = Element.prototype.off = dawn.delegate.off;
  
  dawn.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  

  dawn.dawnLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
 dawn.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  dawn.Sections.prototype = Object.assign({}, dawn.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (dawn && dawn.initGlobals) {
        dawn.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
 
  window.vimeoApiReady = function () {
    dawn.config.vimeoLoading = true
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        dawn.config.vimeoReady = true
        dawn.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }
  
  function checkIfVimeoIsReady () {
    let wait
    let timeout
  
    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }
  
        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)
  
      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }
  
  dawn.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }
  
    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }
  
      this.setAsLoading()
  
      if (dawn.config.vimeoReady) {
        this.init()
      } else {
        dawn.dawnLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId
  
        this.videoPlayer = new Vimeo.Player(this.el, args)
  
        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },
  
      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')
  
        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }
  
        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }
  
        this.setAsLoaded()
  
        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })
  
        observer.observe(this.iframe)
      },
  
      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },
  
      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },
  
      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },
  
      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },
  
      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })
  
    return VimeoPlayer
  })()
  
  window.onYouTubeIframeAPIReady = function() {
    dawn.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  dawn.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in dawn.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (dawn.config.youTubeReady) {
        this.init();
      } else {
        dawn.dawnLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  dawn.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new dawn.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new dawn.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  dawn.loadImageSection = function(container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }
  
    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }
  
    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };
  
    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }
  
    var interval = setInterval(function() {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };
  dawn.dawnSlideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slides',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: dawn.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', dawn.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  dawn.dawnSlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        dawn.dawninitWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slides');
  
        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          dawn.loadImageSection(this.slideshow);
        }
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };
  
          this.flickity = new dawn.dawnSlideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  dawn.DawnBeforeAfter = (function() {
    var defaults = { 
       cellAlign: 'center',
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true
    };
  
    function DawnBeforeAfter(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#BeforeAfter-' + sectionId); 
      this.namespace = '.before-after-' + sectionId;
  
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    DawnBeforeAfter.prototype = Object.assign({}, DawnBeforeAfter.prototype, {
      init: function() {
 
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaults); 
   
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();  
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play(); 
        }
      },
  
      onBlockSelect: function(evt) {
      clearTimeout(this.timeout);  
        if (this.flickity && typeof this.flickity.pause === 'function') { 
          this.flickity.pause(); 
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play(); 
        }
      }
    });
  
    return DawnBeforeAfter;
  })();
  dawn.Testimonials = (function() {
    var defaults = { 
       cellAlign: 'left',
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  dawn.collectionSection = (function() {
    var defaultscollectionSection = { 
       cellAlign: 'left',
        adaptiveHeight: false,
      imagesLoaded: true,
      avoidReflow: true,
      draggable: false,
      pageDots: false,
      prevNextButtons: true
    };
        console.log('pp')
      function collectionSection(container) {
      
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slider-' + sectionId);
      this.namespace = '.product-grid-slider-' + sectionId;
  
      if (!this.slideshow) { return }
   
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 100
      });
        //this.flickity = new dawn.dawnSlideshow(this.slideshow, defaultscollectionSection);
    }
      collectionSection.prototype = Object.assign({}, collectionSection.prototype, {
      init: function()  {
   console.log('ff')
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaultscollectionSection);
     // Autoscroll to next slide on load to indicate more blocks
        console.log(this.slideshow.dataset.count)
     /*   if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }*/
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {  
        console.log(evt)
      /*  var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }*/
        clearTimeout(this.timeout);  
        if (this.flickity && typeof this.flickity.pause === 'function') { 
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return collectionSection;
  })();
  dawn.productGallery = (function() {
      var defaultsproductGallerySection = {  
         adaptiveHeight: true, 
         contain: true, 
         prevNextButtons: false,
         pageDots: false
      };
     function productGallerySection(container) {
      this.container = container;
      this.timeout; 
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slider-Gallery-' + sectionId);  
       this.namespace = '.Slider-Gallery-' + sectionId;
       this.sectionIds = '#Slider-Gallery-' + sectionId;
       this.MediaGallery = '#MediaGallery-' + sectionId;
       this.SliderThumbnails = "#Slider-Thumbnails-" + sectionId+" li"; 
  
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    productGallerySection.prototype = Object.assign({}, productGallerySection.prototype, {
      
    init: function()  {
      this.flickity = new dawn.dawnSlideshow(this.slideshow, defaultsproductGallerySection); 
      console.log(this.SliderThumbnails)
      var $carousel = $(this.sectionIds).flickity({ 
            avoidReflow: true,
           contain: true, 
           prevNextButtons: false,
           pageDots: false
       });
      
      var $carouselNavArowNEXT = $(this.MediaGallery).find('.product__thumb-arrow--next'); 
      var $carouselNavArowPREV = $(this.MediaGallery).find('.product__thumb-arrow--prev'); 
      var $carouselNav = $(this.MediaGallery).find('.product__thumbs--scroller');
      var $carouselNavCells = $carouselNav.find('.slider__slide'); 
      $carouselNav.on( 'click', '.slider__slide', function( event ) {        
        var index = $( event.currentTarget ).index();   
        $carousel.flickity( 'select', index, false, true );
        $carousel.flickity('resize');
      });
      
      var flkty = $carousel.data('flickity');
      var navCellHeight = $carouselNavCells.height();
      var navHeight = $carouselNav.height();

      $carousel.on( 'select.flickity', function() {
        // set selected nav cell
        $carouselNav.find('.is-active').removeClass('is-active');
        
        var $selected = $carouselNavCells.eq( flkty.selectedIndex )
          .addClass('is-active');
       
        var scrollY = $selected.position().top +
          $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
        $carouselNav.animate({
          scrollTop: scrollY
        });
      });
       var SliderThumbnailLoop = this.SliderThumbnails; 
     $carouselNavArowNEXT.on( 'click', function() {  
        $(SliderThumbnailLoop).each(function(index) {
        if($(this).hasClass('is-active')){
           $(this).next().trigger('click');
           $(this).next().find('button').trigger('click');
           $carousel.flickity('resize'); 
           return false;
        }
        });  
      }); 
      
     $carouselNavArowPREV.on( 'click', function() {          
        $(SliderThumbnailLoop).each(function(index) {
        if($(this).hasClass('is-active')){
           $(this).prev().trigger('click');
           $(this).prev().find('button').trigger('click');   
           $carousel.flickity('resize'); 
           return false;
        }
        }); 
      }); 
      
    }
    });
    return productGallerySection;
  })();
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  dawn.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }
  
        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      dawn.utils.prepareTransition(container, function() {
  
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  dawn.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container; 
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {       
        // Re-hook up collapsible box triggers
        dawn.collapsibles.init(this.container);
      },
  
      onUnload: function() {
       
      }
    });
  
    return FooterSection;
  })(); 
  
  dawn.videoGallerySection = (function() {
     var defaults = {    
      contain: true,
      adaptiveHeight: true,
      avoidReflow: false,
      pageDots: false,
      prevNextButtons: true
    };
      function videoGallerySection(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      var sectionTotalBlock = parseInt(container.getAttribute('data-section-block'));
      var sectionPerRow = parseInt(container.getAttribute('data-section-block-per-row'));
      this.slideshow = container.querySelector('#Video-slider-' + sectionId);
      this.namespace = '.video-' + sectionId;

      if (sectionTotalBlock <= sectionPerRow) { console.log('true'); return true; }
          console.log(sectionTotalBlock+' > '+sectionPerRow);
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
      videoGallerySection.prototype = Object.assign({}, videoGallerySection.prototype, {
      init: function()  {
  
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaults);
   
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {   
        clearTimeout(this.timeout);  
        if (this.flickity && typeof this.flickity.pause === 'function') { 
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return videoGallerySection;
  })();
  dawn.promoGallerySection = (function() {
     var defaults = { 
       cellAlign: 'left',   
      contain: true,
      adaptiveHeight: true,
      avoidReflow: false,
      pageDots: false,
      prevNextButtons: true
    };
      function videoGallerySection(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      var sectionTotalBlock = parseInt(container.getAttribute('data-section-block'));
      var sectionPerRow = parseInt(container.getAttribute('data-section-block-per-row'));
      this.slideshow = container.querySelector('#Promo-slider-' + sectionId);
      this.namespace = '.promo-' + sectionId;

 
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
      videoGallerySection.prototype = Object.assign({}, videoGallerySection.prototype, {
      init: function()  {
  
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaults);
   
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {   
        clearTimeout(this.timeout);  
        if (this.flickity && typeof this.flickity.pause === 'function') { 
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return videoGallerySection;
  })();
  dawn.iconGallerySection = (function() {
     var defaults = {    
      contain: true,
      adaptiveHeight: true,
      avoidReflow: false,
      pageDots: false,
      prevNextButtons: true
    };
      function iconGallerySection(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id'); 
      this.slideshow = container.querySelector('#icon-slider-' + sectionId);
      this.namespace = '.text-with-icons-' + sectionId;
 
      if (!this.slideshow) { return }
  
      dawn.dawninitWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
      iconGallerySection.prototype = Object.assign({}, iconGallerySection.prototype, {
      init: function()  {
  
        this.flickity = new dawn.dawnSlideshow(this.slideshow, defaults);
   
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {   
        clearTimeout(this.timeout);  
        if (this.flickity && typeof this.flickity.pause === 'function') { 
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return iconGallerySection;
  })();
   
  dawn.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        dawn.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);
  
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      dawn.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
 
  dawn.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new dawn.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })(); 
 

/*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  } 
  dawn.initGlobals = function() { 
  //  dawn.videoModal();
     dawn.collectionSection();
  }

  DOMready(function(){
    dawn.sections = new dawn.Sections();
      
    dawn.sections.register('slideshow-section', dawn.dawnSlideshow);    
    dawn.sections.register('dawn-slideshow-section', dawn.dawnSlideshowSection);
    dawn.sections.register('testimonials', dawn.Testimonials);
    dawn.sections.register('video-section', dawn.VideoSection); 
    dawn.sections.register('collection-section', dawn.collectionSection);  
    dawn.sections.register('dawn-before-after', dawn.DawnBeforeAfter);  
    dawn.sections.register('product-gallery', dawn.productGallery);  
    dawn.sections.register('footer-section', dawn.FooterSection);  
    dawn.sections.register('text-with-icons-slider', dawn.iconGallerySection);
    dawn.sections.register('newsletter-popup', dawn.NewsletterPopup);
      const mediaQuery = window.matchMedia('(min-width: 768px)') 
      const maxmediaQuery = window.matchMedia('(max-width: 767px)') 
    
    // Check if the media query is true
    if (mediaQuery.matches) {
      console.log('fff') 
       dawn.sections.register('video-slider', dawn.videoGallerySection); 
    }
    // Check if the media query is true
    if (maxmediaQuery.matches) {
      console.log('fff') 
       dawn.sections.register('promo-grid', dawn.promoGallerySection); 
    }
 
    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
})(); 
$(function() {
 
  $(".display-counter").each(function () {
    $(this)
      .prop("Counter", 100)
      .animate(
        {
          Counter: $(this).text()
        },
        {
          duration: 3000,
          easing: "swing",
          step: function (now, tween) {
            // Check added for decimal number
            if(parseInt(tween.end) == parseFloat(tween.end)){
              $(this).text(Math.ceil(now));
            } else{
              $(this).text(now.toFixed(2));
            }
          },
        }
      );
  });
  $(".display-counters").each(function () {
    $(this)
      .prop("Counter", 10000000)
      .animate(
        {
          Counter: $(this).text()
        },
        {
          duration: 3000,
          easing: "swing",
          step: function (now, tween) {
            // Check added for decimal number
            if(parseInt(tween.end) == parseFloat(tween.end)){
              $(this).text(Math.ceil(now));
            } else{
              $(this).text(now.toFixed(2));
            }
          },
        }
      );
  });
    if (!$(".block__audit-service-card-images-slider-one").hasClass("slick-initialized")) {
    $(".block__audit-service-card-images-slider-one").slick({
      draggable: false,
      infinite: true,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 0,
      speed: 6000,
      slidesToShow: 4,
      pauseOnHover: false,
      cssEase: 'linear',
      vertical: true
    });
  }

  if (!$(".block__audit-service-card-images-slider-two").hasClass("slick-initialized")) {
    $(".block__audit-service-card-images-slider-two").slick({
      draggable: false,
      infinite: true,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 0,
      speed: 8000,
      slidesToShow: 4,
      pauseOnHover: false,
      cssEase: 'linear',
      vertical: true
    });
  }
  if (!$(".block__audit-service-card-images-slider-three").hasClass("slick-initialized")) {
    $(".block__audit-service-card-images-slider-three").slick({
      draggable: false,
      infinite: true,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 0,
      speed: 10000,
      slidesToShow: 4,
      pauseOnHover: false,
      cssEase: 'linear',
      vertical: true
    });
  }
    if ($(".block__audit-service-card-exp-date-js").length) {
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var lastDay = new Date(y, m + 1, 0);
    var month_name = lastDay.toLocaleString("en-US", { month: "long" });
    var month_year = lastDay.getFullYear();
    var month_end_date = lastDay.getDate();
    var month_number = lastDay.getMonth() + 1;
    $(".block__audit-service-card-exp-date-js").text(month_name + " " + month_end_date + ", " + month_year);
    if ($(".block__audit-service-card-exp-time-days-js").length) {
      MonthDayCounter(month_number, month_end_date, month_year)
    }
  }

  function MonthDayCounter(month_number, month_end_date, month_year) {
    const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
    var birthday = month_number + "/" + month_end_date + "/" + month_year;
    const countDown = new Date(birthday).getTime(),
      x = setInterval(function () {
        const now = new Date().getTime(), distance = countDown - now;
        $(".block__audit-service-card-exp-time-days-js").text(Math.floor(distance / (day)));
        $(".block__audit-service-card-exp-time-hours-js").text(Math.floor((distance % (day)) / (hour)));
      }, 0)
  }
    $(document).on("click", ".block__checkout-extensibility-tabs-title", function () {
    if ($(this).hasClass("change_icon")) {
      $(this).removeClass("change_icon");
      $(this).parents(".block__checkout-extensibility-tabs-slide").find(".block__checkout-extensibility-tabs-panel").slideUp();
    } else {
      $(".block__checkout-extensibility-tabs-title").removeClass("change_icon");
      $(".block__checkout-extensibility-tabs-panel").slideUp();
      $(this).addClass("change_icon");
      $(this).parents(".block__checkout-extensibility-tabs-slide").find(".block__checkout-extensibility-tabs-panel").slideDown();
    }
  });
  $(document).on("click", ".block__chosse-checkout-extensibility-icon-heading-list", function () {
    var data_id = $(this).attr("data-id");
    $(".block__chosse-checkout-extensibility-icon-heading-list").removeClass("active");
    $(this).addClass("active");
    $(".block__chosse-checkout-extensibility-icon").addClass("hidden");
    $(".block__chosse-checkout-extensibility-icon." + data_id).removeClass("hidden");
    $(".block__chosse-checkout-extensibility-block-description").addClass("hidden");
    $(".block__chosse-checkout-extensibility-block-description." + data_id).removeClass("hidden");
  });
  // Bulk hours quote form end
  function resizeRight() {
    let left = $('.ui-ux-slide-left ').height()
    let het = $('.ui-ux-slide-right').css("max-height", left);
  };
  $(window).resize(function () {
    resizeRight();
  });
  if ($(".ui-ux-slide-left").length > 0) {
    resizeRight();
  }


  $(document).on("click", ".tabs_title", function () { 

    if (!$(this).hasClass("change_icon")) {
      $(".tabs_title").removeClass("change_icon");
      $(".tabs_title").parent().find(".panel").slideUp();
      $(this).addClass("change_icon");
      $(this).parent().find(".panel").slideDown();
    }
    // }
    if ($(".ui-ux-slide-left").length > 0) {
      let inteval = setInterval(() => {
        resizeRight();
      }, 100)
      setTimeout(() => {
        clearInterval(inteval);
      }, 2000)
    }
  });
  
  $(".column_list_one").slick({
    draggable: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });
  $(".column_list_two").slick({
    draggable: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 0,
    speed: 6000,
    pauseOnHover: false,
    cssEase: 'linear',
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });
  $(".column_list_three").slick({
    draggable: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 0,
    speed: 10000,
    pauseOnHover: false,
    cssEase: 'linear',
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });
    $(window).scroll(function () {
    if ($('.custom_store_section').length) {
      var section_id = $('.custom_store_section').offset().top;
      var window_height = $(window).height() / 2;
      var window_scroll = $(this).scrollTop() + $("#shopify-section-sections--16550926581830__header").height() + window_height;
      if (window_scroll >= section_id) {
        if ($(".services_left_content").hasClass("active_count")) {
          $.fn.jQuerySimpleCounter = function (options) {
            var settings = $.extend({
              start: 0,
              end: 100,
              easing: 'swing',
              duration: 400,
              complete: ''
            }, options);

            var thisElement = $(this);
            $({ count: settings.start }).animate({ count: settings.end }, {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                if (thisElement[0].classList.contains("custom_index_2")) {
                  var mathCount = this.count;
                  thisElement.text("$" + mathCount.toFixed(1) + "M+");
                } else {
                  var mathCount = Math.ceil(this.count);
                  thisElement.text(mathCount);
                }
              },
              complete: settings.complete
            });
          };
          if ($('.custom_index_1 .count_number').length) {
            var count_one = parseInt($('.custom_index_1 .count_number').attr("data_number"));
            $('.custom_index_1 .count_number').jQuerySimpleCounter({ end: count_one, duration: 3000 });
          }
          if ($('.custom_index_3 .count_number').length) {
            var count_two = parseInt($('.custom_index_3 .count_number').attr("data_number"));
            $('.custom_index_3 .count_number').jQuerySimpleCounter({ end: count_two, duration: 3000 });
          }
          if ($(".custom_index_2").length) {
            $(".custom_index_2").jQuerySimpleCounter({ end: 18, duration: 3000 });
          }
          if ($('.custom_index_4 .count_number').length) {
            var count_four = parseInt($('.custom_index_4 .count_number').attr("data_number"));
            $('.custom_index_4 .count_number').jQuerySimpleCounter({ end: count_four, duration: 3000 });
          }
          $(".services_left_content").removeClass("active_count");
        }
      }
    }
  }).scroll();
    var $cases = $('.js-wall-container');
  var $leadCarousel = $('.leadgen-image-carousel');

  // If neither element exists, stop completely
  if (!$cases.length && !$leadCarousel.length) {
    console.warn('No .js-wall-container or .leadgen-image-carousel found.');
    return;
  }

  var windowHeight = window.innerHeight;

  // Compute safe offsets
  var cases_eTop = $cases.length ? $cases.offset().top : 0;
  var cases_height = $cases.length ? windowHeight + $cases.outerHeight() : 0;

  var lead_eTop = $leadCarousel.length ? $leadCarousel.offset().top : 0;
  var lead_height = $leadCarousel.length ? windowHeight + $leadCarousel.outerHeight() : 0;

  $(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();

    // === Wall Parallax ===
    if ($cases.length) {
      var cases_scrollTop = cases_eTop - scrollTop,
          cases_bottom = windowHeight - cases_scrollTop;

      if (cases_bottom > 0 && cases_bottom < cases_height) {
        var cases_transform = cases_bottom * 0.1;

        anime({
          targets: '.js-wall-container > span:nth-child(odd)',
          translateX: -cases_transform + 'px',
          easing: 'linear',
          duration: 0
        });
        anime({
          targets: '.js-wall-container > span:nth-child(even)',
          translateX: cases_transform + 'px',
          easing: 'linear',
          duration: 0
        });
      }
    }

    // === Lead Carousel Parallax ===
    if ($leadCarousel.length) {
      var lead_scrollTop = lead_eTop - scrollTop,
          lead_bottom = windowHeight - lead_scrollTop;

      if (lead_bottom > 0 && lead_bottom < lead_height) {
        var lead_transform = lead_bottom * 0.75;

        anime({
          targets: '.leadgen-image-carousel .leadgen-image-carousel-inner',
          translateY: -lead_transform + 'px',
          easing: 'linear',
          duration: 0
        });
      }
    }
  });
    
       
   });
 
        $(document).ready(function() {  
    $(".timeline-item") && (inView.threshold(.5),
    inView(".timeline-item").on("enter", function(e) {
        e.classList.contains("visible") || e.classList.add("visible")
    })); 
    $(".js-inview-element") && (inView.threshold(.5),
    inView(".js-inview-element").on("enter", function(e) {
        e.classList.contains("shown") || (e.classList.add("shown"),
        e.classList.contains("js-inview-campaign") ? anime({
            targets: e.querySelectorAll(".js-inview-child-multiple"),
            scale: [0, 1],
            delay: anime.stagger(50)
        }) : e.classList.contains("js-inview-logowall") ? anime({
            targets: e.querySelectorAll(".js-inview-child-multiple"),
            opacity: [0, 1],
            translateY: ["-20px", "0px"],
            delay: anime.stagger(50)
        }) : e.classList.contains("js-inview-goals") && anime({
            targets: e.querySelectorAll(".js-inview-child-multiple"),
            opacity: [0, 1],
            translateY: ["-20px", "0px"],
            duration: 2e3,
            delay: anime.stagger(60)
        }))
    }));
var n, r, o, s, a,
      e = $(".js-wall-container"),
      t = $(".leadgen-image-carousel");

  // Only continue if at least one exists
  if (!e.length && !t.length) return;

  n = window.innerHeight;

  // Safe offset/height values
  r = e.length ? e.offset().top : 0;
  o = e.length ? n + e.outerHeight() : 0;
  s = t.length ? t.offset().top : 0;
  a = t.length ? n + t.outerHeight() : 0;

  $(window).on("scroll", function() {
    var scrollTop = $(window).scrollTop();

    // Wall animation
    if (e.length) {
      var u = n - (r - scrollTop);
      if (u > 0 && u < o) {
        var m = 0.1 * u;
        anime({
          targets: ".js-wall-container > span:nth-child(odd)",
          translateX: -m + "px",
          easing: "linear",
          duration: 0
        });
        anime({
          targets: ".js-wall-container > span:nth-child(even)",
          translateX: m + "px",
          easing: "linear",
          duration: 0
        });
      }
    }

    // Leadgen animation
    if (t.length) {
      var v = n - (s - scrollTop);
      if (v > 0 && v < a) {
        anime({
          targets: ".leadgen-image-carousel .leadgen-image-carousel-inner",
          translateY: -(0.75 * v) + "px",
          easing: "linear",
          duration: 0
        });
      }
    }
  });
});

'use strict';

var workingWeekend = workingWeekend || {};

workingWeekend.frontpage = workingWeekend.frontpage || function () {

    function init() {
        frontpageinits();
    }

    function frontpageinits(){

        $(document).ready(function(){             
            if ( matchMedia('screen and (min-width: 768px)').matches ) {

                var res = Splitting({
                    target: '.split-heading',
                    by: 'lines',
                });

                res.forEach((splitResult) => {
                    const wrappedLines = splitResult.lines.map((wordsArr) => `
                        <span class="line"><span class="mask-up">
                            ${wordsArr.map((word) => `${word.outerHTML}<span class="whitespace">
                        </span>`).join('')}
                    </span></span>`).join('');
                    splitResult.el.innerHTML = wrappedLines;
                });

                inView.threshold(0.75);
                inView(".split-heading").on("enter", function(el) {
                    if (!el.classList.contains("has-animated")) {
                        el.classList.add("show");
                        anime({
                            targets: el.querySelectorAll(".mask-up"),
                            translateY: ["100%", "0%"],
                            duration: 1500,
                            delay: anime.stagger(250),
                            easing: "easeOutQuint",
                            autoplay: true
                        });
                        el.classList.add("has-animated");

                        var tl = anime.timeline({
                            easing: 'easeOutExpo',
                            duration: 1000
                        });

                        tl

                        .add({
                            targets: '.template-index  .header-wrappers',
                            translateY:[-100,0],
                            duration:250
                        })
                        .add({
                            targets: '.frontpage-browser-img',
                            scale: [2,1],
                            delay: 500
                        })
                        .add({
                            targets: '.frontpage-browser-pop',
                            translateX: [600,0],
                            translateY: [200,0],
                            opacity: [0,1],
                        }, '-=700')
                        .add({
                            targets: '.browser-headline',
                            translateX: [300,0],
                            translateY: [-100,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.browser-text',
                            translateX: [300,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.browser-button',
                            translateX: [300,0],
                            translateY: [100,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.frontpage-browser-outline',
                            opacity: [0,1],
                        }, '-=700')
                        .add({
                            targets: '.frontpage-browser-buttons',
                            opacity: [0,1],
                        }, '-=1000')
                        .add({
                            targets: ".block__audit-service-card-details-description p, .hero__link a, .block__audit-service-card-details ul",
                            translateY:[100,0],
                            opacity:[0,1]
                        }, '1200')
                        ; 
                    }
                });

                
                
            }
        });

    }


    return {
        init:init
    };


}();
workingWeekend.frontpage.init();